import { useEffect, useRef, useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import Spinner from "../../Components/UI/Spinner/Spinner";
import "./style.css";
import { useFormik } from "formik";
import Table from "../../Components/UI/Table/Table";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
// import { AddCTargetingAction, GetCTargetingListAction, GetCTargetingSegmentsAction } from "../../Redux/Actions/CtargetingActions";
import { GetUserInfoNG } from "../../Redux/Actions/UserInfoNGActions"
// import ListComponent from "./ListComponent";
import { IReduxState } from "../../utils/types";
import CsvDownloader from "react-csv-downloader";




const UserInfoNG = () => {
  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const userInfoState = useSelector((state: IReduxState) => state.UserInfoNG);

  const userIDtypes = [ "EYield", "TYield", "Sync_User", "Sync_Domain","AH_User"];
  
  const dispatch = useDispatch()
  const fileUploadRef = useRef<HTMLInputElement>(null);
  const [csvFiler, setCsvFiler] = useState<any>({});
  const [tableData, setTableData] = useState<any[]>([]); // new

  const cols = [
  {
    Header: "KEY",
    accessor: "key"
  },
  {
    Header: "VALUE",
    accessor: "value",
    Cell: ({ row }: any) => {
      const key = row.original.key;
      const value = row.original.value;
      if (key === "csvFile" && value) {
        return (
          <a href={value as string} target="_blank" rel="noopener noreferrer">
            {value as string}
          </a>
        );
      }
      return <span>{value as string}</span>;
    }
  }
];

  const conditions:any = {
    EYield: AuthState.eyield,
    TYield: AuthState.tyield,
    Sync_User: AuthState.sync_user,
    Sync_Domain: AuthState.sync_domain,
    AH_User: AuthState.ah_user,
  };

    let newColumns = cols.map((column: any) => ({
    id: column.Header,
    displayName: column.Header,
  }));

  const filteredArray = userIDtypes.filter(type => conditions[type]);

  const handleFileUpload = () => {
    if (fileUploadRef) {
      fileUploadRef?.current?.click();
    }
  }


  const handleCSVUpload = (event: any) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    // Check if the selected file is a CSV file
    if (fileObj && fileObj.name.endsWith('.csv')) {
      setCsvFiler(fileObj);
      formik.setFieldValue("csvFileName", fileObj.name);

      const reader = new FileReader();
      reader.onload = (eventer) => {
        const content = eventer.target?.result as string;
        const lines = content.split(/\r\n|\r|\n/);
        const filteredLines = lines.filter(line => line.trim() !== "");
      };
      reader.readAsText(fileObj);
    } else {
      alert('Please select a valid CSV file.');
      event.target.value = null; // Clear the input field
    }
  }

  const resetCsvInput = () => {
  if (fileUploadRef.current) {
    fileUploadRef.current.value = "";
  }
};




  const formik = useFormik({
    initialValues: {
      user_id: ["admin"].some(role => AuthState.role.includes(role)) || AuthState.cjscIds.length > 1 ? AuthState.id : "",
      type: filteredArray[0],
      time_frame: "0",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      isCsv: false,
      csvFileName: "",
      csvfile: "",
    },
    onSubmit: (value, { resetForm }) => {
      // console.log("value", value);
      // const formData = new FormData();
      const formData = new FormData();
      formData.append('csvFileName', value.csvFileName);
      formData.append('csvfile', csvFiler);
      formData.append('isCsv', value.isCsv ? "true" : "false");
      formData.append('user_id', value.user_id);
      formData.append('type', value.type);
      formData.append('time_frame',value.time_frame);
      formData.append('value1', value.value1);
      formData.append('value2', value.value2);
      formData.append('value3', value.value3);
      formData.append('value4', value.value4);
      formData.append('value5', value.value5);
      formData.append('value6', value.value6);



      dispatch(GetUserInfoNG(formData))
      setCsvFiler({});
      resetCsvInput();
      setTableData([]);
      resetForm({
        values: {
          // type: filteredArray[0],
          user_id: value.user_id,
          type: formik.values.type,
          time_frame: value.time_frame,
          value1: value.value1,
          value2: value.value2,
          value3: value.value3,
          value4: value.value4,
          value5: value.value5,
          value6: value.value6,
          // value2: "",
          // value3: "",
          // value4: "",
          // value5: "",
          // value6: "",
          isCsv: value.isCsv,
          csvFileName: "",
          csvfile: ""
        }
      })
    },
  });


  const downloadCSVFile = () => {
    let csvContent: any;
    let fileName;
    csvContent = "AADbIE7MiYQAABUzAjtgTg\nAAGI3E7Mm2QAABUVNaeASg\nBAFAE7Mn4RaABPVTaeASgT";
    fileName = 'User_Info_Example';

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.csv`;

    a.click();
    window.URL.revokeObjectURL(url);
}

useEffect(() => {
  setTableData(userInfoState?.data?.userData ? userInfoState.data.userData : []);
}, [userInfoState?.data]); 

useEffect(() => {
  if (formik.values.isCsv) {
    formik.setFieldValue("value1", "");
    formik.setFieldValue("value2", "");
    formik.setFieldValue("value3", "");
    formik.setFieldValue("value4", "");
    formik.setFieldValue("value5", "");
    formik.setFieldValue("value6", "");
  } else {
    formik.setFieldValue("csvFileName", "");
  }
  resetCsvInput();
  setCsvFiler({});
},[formik.values.isCsv]);



  return (
    <>
      {userInfoState?.loading && (<div className="popUpUser"><Spinner className="m-2" color={"primary"}></Spinner></div>)}
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <h3 className="module_title">
            User Info
          </h3>
        </Row>
      </Row>
      <Card>
      
        <Row style={{ padding: "15px" }}>
          {(
          ["admin"].some(role => AuthState.role.includes(role)) 
          || 
          AuthState.subUsers.length > 1 )
          && 
          (
          <Row>
            <Col lg={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={2}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  {"         "}
                </Form.Label>
                <Col lg={5}>
                  <Form.Select
                    name="user_id"
                    value={formik.values.user_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem "
                  >
                            {AuthState.subUsers
                              .slice()
                              .sort((a: any, b: any) => a.name.localeCompare(b.name))
                              .map((subuser: any, index: any) => (
                                <option key={index} value={subuser._id}>
                                  {subuser.name}
                                </option>
                            ))}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          )}
          <Row>
            <Col lg={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={2}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  Users Type
                </Form.Label>
                <Col lg={5}>
                  <Form.Select
                    name="type"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem "
                  >
                             {filteredArray.map((type, index) => (
          <option key={index}>{type}</option>
        ))}               
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>
           {formik.values.type === "Sync_Domain" && (
          <Row>
            <Col lg={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={2}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  Time Frame
                </Form.Label>
                <Col lg={5}>
                  <Form.Select
                    name="time_frame"
                    value={formik.values.time_frame}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem "
                  >
                    <option value="0">Today</option>
                    <option value="2">Last 2 days</option>
                    <option value="7">Last 7 Days</option>
                    <option value="-1">All</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>
           )}
          <Row>
            <Col lg={14}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={1} id="smallerFontSize">
                  Upload Type
                </Form.Label>
                <Col lg={11}>
                  <div className="checkboxes" >
                    <Form.Check
                      type="radio"
                      name="csvType"
                      value="off"
                      onChange={() => formik.setFieldValue("isCsv", false)}
                      checked={formik.values.isCsv === false ? true : false}
                    />{" "}
                    <Form.Label
                      style={{ marginLeft: "15px" }}
                      column
                      lg={2}
                      id="smallerFontSize"
                    >
                      {" "}
                      Single Users{" "}
                    </Form.Label>
                    <Form.Check
                      type="radio"
                      name="csvType"
                      value="on"
                      onChange={() => formik.setFieldValue("isCsv", true)}
                      checked={formik.values.isCsv === true ? true : false}
                    // onBlur={formik.handleBlur}
                    ></Form.Check>{" "}
                    <Form.Label
                      style={{ marginLeft: "15px" }}
                      column
                      lg={2}
                      id="smallerFontSize"
                    >
                      {" "}
                      CSV File{" "}
                    </Form.Label>
                  </div>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          </Row>
      </Card>
      <Card>
        <Row style={{ padding: "15px" }}>
          <Row>
            <Col lg={15}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={1}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  CSV File
                </Form.Label>
                <input
                  name="csvfile"
                  aria-label="csvfile"
                  ref={fileUploadRef}
                  style={{ display: 'none' }}
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleCSVUpload(e)}
                />
                <Col lg={1}>
                  <Button className="m-0" variant="primary" disabled={!formik.values.isCsv} onClick={() => handleFileUpload()}>Upload CSV</Button>
                </Col>
                <Col className="col-9 col-md-6">
                  <Form.Control
                    name="csvFileName"
                    value={formik.values.csvFileName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    disabled={!formik.values.isCsv}
                  />
                </Col>
                <Col lg={2}>
                  {/* <div className="d-flex flex-wrap gap-2"> */}
                    <span
                      style={{
                        textDecoration: "none",
                        color: "#0077b6",
                        fontWeight: "bold",
                        // margin: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => downloadCSVFile()}
                    >
                      Download CSV Example
                    </span>
                  {/* </div> */}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #1
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value1"
                    disabled={formik.values.isCsv}
                    value={formik.values.value1}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value1}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value1} </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #2
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value2"
                    disabled={formik.values.isCsv}
                    value={formik.values.value2}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value2}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value2} </Form.Control.Feedback>
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #3
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value3"
                    disabled={formik.values.isCsv}
                    value={formik.values.value3}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value3}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value3} </Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #4
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value4"
                    disabled={formik.values.isCsv}
                    value={formik.values.value4}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value4}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value4} </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #5
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value5"
                    disabled={formik.values.isCsv}
                    value={formik.values.value5}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value5}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value5} </Form.Control.Feedback>
                </Col>
              </Form.Group>


              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  value #6
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value6"
                    disabled={formik.values.isCsv}
                    value={formik.values.value6}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value6}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value6} </Form.Control.Feedback>
                </Col>
              </Form.Group>


            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col>
              <Button
                style={{ marginLeft: "0", fontWeight: "700" }}
                variant="primary"
                onClick={() => {
                  formik.handleSubmit();
                  // setCsvFiler("");
                }}
                disabled={(formik.values.isCsv && formik.values.csvFileName==="") || (!formik.values.isCsv && formik.values.value1 === "" && formik.values.value2 === "" && formik.values.value3 === "" &&
                  formik.values.value4 === "" && formik.values.value5 === "" && formik.values.value6 === "")}
              >
                Submit
              </Button>

            </Col>
          </Row>
        </Row>
      </Card>

      <Card>
        
        <Row style={{ padding: "15px" }}>
          <Col md="auto" className="d-flex align-items-end ms-auto me-3">
        <CsvDownloader
                          columns={newColumns}
                          datas={userInfoState?.data?.userData?userInfoState.data.userData.map((row : any) => ({ KEY: row.key, VALUE: `"${row.value}"`})):[]}
                          text="Export to CSV"
                          filename={`userinfo_` + new Date().toLocaleString()}
                          extension=".csv"
                          className="btn btn-primary ExportBtn no-margin"
                          style={{ marginBottom: "0px" }}
                        />
                      </Col>
        {userInfoState.loading && (<div className="popUpUser"><Spinner className="m-2" color={"primary"}></Spinner></div>)}
              <Table
                columns={cols}
                data={tableData} // new
                // data={userInfoState?.data?.userData?userInfoState.data.userData:[]}
                striped={true}
              />
          {/* <ListComponent historyData={cTargetingState.historyData} upload_segmets={cTargetingState?.segmentData} /> */}
        </Row>
      </Card>
    </>
  );
};

export default UserInfoNG;